import { HierarchyFiltersState } from "@domain/model/HierarchyFiltersState";

export interface IHierarchyFiltersService {
  persistedState?: HierarchyFiltersState;
  saveHierarchyFiltersState(newState: HierarchyFiltersState): void;
  clearHierarchyFiltersState(): void;
}

export const HierarchyFiltersService = Symbol.for("HierarchyFiltersService");
